import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import Dropdown from 'src/components/Dropdown/Dropdown';
import { clearAppState } from 'src/redux/logout/logout.action';
import { AbsolutePosition } from 'src/lib/StyledComponents';
import theme from 'src/lib/theme';

class Logout extends React.Component {
	logout = () => {
		this.props.clearAppState();
		delete localStorage.wiselyToken;
	};

	render() {
		return (
			<AbsolutePosition top="20px" right="40px">
				<Dropdown>
					<Link
						onClick={this.logout}
						style={{ color: theme.colors['yankees-blue'], textDecoration: 'initial' }}
						to="/login"
					>
						Logout
					</Link>
				</Dropdown>
			</AbsolutePosition>
		);
	}
}

const actions = {
	clearAppState,
};

Logout = connect(null, actions)(Logout);

export default Logout;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/Logout/index.js